import useRequest from 'src/hook/useRequest'
import { PublicationEndpoints } from 'src/client/publication/constants'
import { getPostImage } from 'src/client/publication'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { PostType } from 'src/pages/communityPost/communityPost.types'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { useUser } from 'src/hook/useUser'
import { getImageDimensions } from '../../components/postImage/postImage.utils'
import { UsePostImageProps } from './usePostImage.types'
import { DEFAULT_IMAGE_SIZE } from './usePostImage.constants'

const usePostImage = ({ post, enabled = true }: UsePostImageProps) => {
  const { authStatus } = useUser()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const url = isUnauthenticated
    ? PublicationEndpoints.getPublicPostImage(post.id)
    : PublicationEndpoints.getPostImage(post.id)

  const response = useRequest(
    url,
    /* istanbul ignore next */
    () =>
      getPostImage({
        publicationId: post.id,

        /**
         * This implementation will be removed when the new endpoint
         * that returns the image is implemented.
         */
        imageDimension: getImageDimensions({
          mediaWidth: post.postType === PostType.URL ? DEFAULT_IMAGE_SIZE.width : post.mediaWidth,
          mediaHeight: post.postType === PostType.URL ? DEFAULT_IMAGE_SIZE.height : post.mediaHeight
        }),
        isUnauthenticated
      }),
    {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  )

  return {
    ...response,
    isLoading: enabled ? response.isLoading : false
  }
}

export default usePostImage
